import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import '../styles/AnalyticalSensors.css';
import { FaFilePdf, FaChevronRight, FaEnvelope } from 'react-icons/fa';
import WhatsAppModal from './WhatsAppModal';

import analyticImg from '../assets/analytical-main.png';
import sensor1 from '../assets/pH_Meter.jpg';
import sensor2 from '../assets/Conductivity_Sensor.jpg';
import sensor3 from '../assets/COD_Sensor.jpg';
import CatalogPDF from '../assets/Fu-Tek ANALYTICAL SENSORS_pH_TDS_COD_BOD Sensor.pdf';
import ANALYTICALSENSORS_pHPDF from '../assets/Analytical sensors/ANALYTICAL SENSORS_pH.pdf';
import ANALYTICALSENSORS_conductivityPDF from '../assets/Analytical sensors/ANALYTICAL SENSORS_conductivity.pdf';
import ANALYTICALSENSORS_codPDF from '../assets/Analytical sensors/ANALYTICAL SENSORS_cod.pdf';

export default function AnalyticalSensors() {
  const [activeTab, setActiveTab] = useState('ph');
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="AnalyticalSensors-wrapper">
      <Header />

      {/* Hero Section */}
      <div className="hero-banner24">
        <div className="hero-banner24-content">
          <h1>ANALYTICAL SENSORS</h1>
          <div className="sensor-breadcrumb">
            <a href="/">Home</a> <FaChevronRight /> <span>Analytical sensors</span>
          </div>
        </div>
      </div>

      {/* Intro Section */}
      <div className="sensor-intro">
        <img src={analyticImg} alt="Analytical Sensors" />
        <div className="sensor-info">
          <h2>Analytical sensors</h2>
          <ul>
            <li>Compact conductivity sensors for the food industry</li>
            <li>Inductive and conductive conductivity sensors</li>
            <li>Robust sensors for the monitoring of oil quality</li>
            <li>Relative humidity and concentration of particles</li>
          </ul>
          <div className="sensor-buttons">
            <a href={CatalogPDF} target="_blank" rel="noopener noreferrer">
              <button className="download-catalog-btn"><FaFilePdf style={{ marginRight: '8px' }} /> Full Catalog Download</button>
            </a>
            <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
            <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="sensor-tabs">
        <button className={activeTab === 'ph' ? 'active' : ''} onClick={() => setActiveTab('ph')}>pH Meter</button>
        <button className={activeTab === 'conductivity' ? 'active' : ''} onClick={() => setActiveTab('conductivity')}>Conductivity Sensor</button>
  <button className={activeTab === 'cod' ? 'active' : ''} onClick={() => setActiveTab('cod')}>COD Sensor</button>
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {/* pH Meter */}
        {activeTab === 'ph' && (
          <div className="level-product-table">
            <div className="level-product-left">
              <div className="sensor-feature-card">
                <img src={sensor1} alt="RCD-AI00-X08R" />
                <h3>RCD-AI00-X08R</h3>
                <a href={ANALYTICALSENSORS_pHPDF} target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn"><FaFilePdf />Download</button>
                </a>
              </div>
            </div>
            <div className="sensor-right">
              <table className="level-spec-table">
                <tbody>
                  <tr><td>Model</td><td>FT-485-pH</td></tr>
                  <tr><td>Parameter measurement</td><td>pH Temperature</td></tr>
                  <tr><td>Measure range</td><td>pH：0.0~14.0; <br/>Temperature：（0~50.0）℃</td></tr>
                  <tr><td>Accuracy</td><td>pH：±0.1pH; <br/>Temperature：±0.5℃</td></tr>
                  <tr><td>Resolution</td><td>pH：0.01pH; <br/>Temperature：0.1℃</td></tr>
                  <tr><td>Power supply</td><td>24V DC</td></tr>
                  <tr><td>Power dissipation</td><td>1W</td></tr>
                  <tr><td>Communication mode</td><td>RS485(Modbus RTU)</td></tr>
                  <tr><td>Cable length</td><td>Can be ODMdepend on user’s requirements</td></tr>
                  <tr><td>Installation</td><td>Sinking type, pipeline, circulation type etc.</td></tr>
                  <tr><td>Overall size</td><td>230mm× 30mm</td></tr>
                  <tr><td>Housing material</td><td>Stainless Steel</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

{/* Conductivity Sensor */}
  {activeTab === 'conductivity' && (
    <div className="level-product-table">
      <div className="level-product-left">
        <div className="sensor-feature-card">
          <img src={sensor2} alt="Conductivity Sensor" />
          <h3>Conductivity Sensor</h3>
          <a href={ANALYTICALSENSORS_conductivityPDF} target="_blank" rel="noopener noreferrer">
            <button className="download-catalog-btn"><FaFilePdf />Download</button>
          </a>
        </div>
      </div>
      <div className="sensor-right">
        <table className="level-spec-table">
<tbody>
  <tr><td>Model</td><td>FT-485-ECG</td></tr>
  <tr><td>Cell constant</td><td>K=1</td></tr>
  <tr><td>Measure Range</td><td>0–20000 μS/cm</td></tr>
  <tr><td>TDS</td><td>0–100000ppm</td></tr>
  <tr><td>Salinity</td><td>0–72ppt</td></tr>
  <tr><td>Temp Range</td><td>0–60℃</td></tr>
  <tr><td>Accuracy</td><td>2%FS ±0.5℃</td></tr>
  <tr><td>Pressure</td><td>0.3MPa</td></tr>
  <tr><td>Resolution</td><td>1 μS/cm, 1ppm, 0.1℃</td></tr>
  <tr><td>Material</td><td>Stainless Steel</td></tr>
  <tr><td>Connection</td><td>Top G1Thread</td></tr>
  <tr><td>Power Supply</td><td>9~36V DC</td></tr>
  <tr><td>Communication</td><td>Modbus RTU</td></tr>
  <tr><td>Protection Grade</td><td>IP68</td></tr>
  <tr><td>Cable Length</td><td>5 meters</td></tr>
</tbody>

        </table>
      </div>
    </div>
  )}

  {/* COD Sensor */}
  {activeTab === 'cod' && (
    <div className="level-product-table">
      <div className="level-product-left">
        <div className="sensor-feature-card">
          <img src={sensor3} alt="COD Sensor" />
          <h3>COD Sensor</h3>
          <a href={ANALYTICALSENSORS_codPDF} target="_blank" rel="noopener noreferrer">
            <button className="download-catalog-btn"><FaFilePdf />Download</button>
          </a>
        </div>
      </div>
      <div className="sensor-right">
        <table className="level-spec-table">
<tbody>
  <tr><td>Measure range</td><td>COD (Use KHP for calibration): 0~500mg/L COD;<br />BOD: 0~250mg/L</td></tr>
  <tr><td>Accuracy</td><td>COD: ±5%; Turbidity: ±10%</td></tr>
  <tr><td>Repeatability</td><td>5%</td></tr>
  <tr><td>Resolution</td><td>COD: 0.01mg/L; Turbidity: 0.01NTU</td></tr>
  <tr><td>Pressure range</td><td>≤ 0.1Mpa</td></tr>
  <tr><td>Material</td><td>Body: SUS316L (freshwater), Titanium alloy (seawater)</td></tr>
  <tr><td>Communication</td><td>MODBUS RS485</td></tr>
  <tr><td>Storage Temp</td><td>-15~50℃</td></tr>
  <tr><td>Working Temp</td><td>0~45℃ (No freeze)</td></tr>
  <tr><td>Dimension/Weight</td><td>Sensor dimension: Dia34mm × L209mm<br />Weight: &lt;0.8KG</td></tr>
  <tr><td>Protection Grade</td><td>IP68</td></tr>
  <tr><td>Cable Length</td><td>3 meters (can be extended)</td></tr>
</tbody>

        </table>
      </div>
    </div>
  )}

      </div>

      <Footer />
    </div>
  );
}
